document.addEventListener('DOMContentLoaded', () => {
  const loadMoreButton = document.getElementById('load-more');
  let currentPage = loadMoreButton.dataset.currentPage;

  loadMoreButton.addEventListener('click', (event) => {
    event.preventDefault();
    event.stopPropagation();

    currentPage++;
    const nextPageUrl = `/blogs/blog?page=${currentPage}`;
    
    fetch(nextPageUrl)
      .then((response) => response.text())
      .then((data) => {
        const parser = new DOMParser();
        const htmlDocument = parser.parseFromString(data, 'text/html');
        const newArticles = htmlDocument.querySelector('#blog-articles').innerHTML;

        document.getElementById('blog-articles').insertAdjacentHTML('beforeend', newArticles);
        document.getElementById('load-more').setAttribute('href', `/blogs/blog?page=${currentPage + 1}`);

        // Hide button if no more articles
        if (!htmlDocument.getElementById('load-more')) {
          loadMoreButton.style.display = 'none';
        }

        window.history.pushState({ page: currentPage }, "", nextPageUrl);
      })
      .catch(error => console.error("Error loading more posts:", error));
  });
});
